import React, { Fragment } from "react";

const getValidInchVal = (val) => val && val !== "-"; // '-' is to filter out values which have not been entered and the app form is saving '-' instead of empty value

const getFractionInches = (values) => {
  let result = "";
  if (values && Array.isArray(values)) {
    let numbers = values.filter(getValidInchVal);
    if (numbers.length === 1) {
      result = numbers[0];
    } else if (numbers.length === 2) {
      result = (
        <Fragment>
          <span style={{ whiteSpace: "nowrap" }}>
            {numbers[0]} <sup>{numbers[1].split("/")[0]}</sup>⁄<sub>{numbers[1].split("/")[1]}</sub>
          </span>
        </Fragment>
      );
    }
  }
  return result;
};

export const SCFE_SwitchInspectionReportSchema = {
  switchSection: {
    title: {
      heights: {
        header1: "auto",
      },
      headerOnly: true,
      classes: {
        header1: "grey-background",
      },
      columns: [
        {
          title: "SWITCH MEASUREMENT",
          colSpan: 29,
          rowSpan: 1,
          className: "tbl-text-normal",
        },
      ],
    },
    header: {
      heights: {
        header1: "200px",
        header2: "100px",
      },
      inlineBodyData: true,
      columns: [
        {
          title: "MILEPOST",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },
        {
          title: "TURNOUT NAME",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },
        {
          title: "COMPONENT",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },
        {
          title: "SW. POINT OPENING",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate-multiline",
        },

        {
          title: "SW. POINT CONDITION",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate-multiline",
        },

        {
          title: "SW. RODS",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,

          className: "tbl-text-rotate",
        },

        {
          title: "STOCK RAIL",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "SW. LOCK",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "SW. LATCH",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "SW. TARGET",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "TURNOUT MAX GAGE",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "FROG CONDITION",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "FROG TRACK GAGE",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "GUARD RAIL CONDITION",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate-multiline",
        },

        {
          title: "GUARD FACE GAGE",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "GUARD CHECK GAGE",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "GAGE MEASUREMENTS OF THROW SW.",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate-multiline",
        },

        {
          title: "TIES",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "ANCHOR",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "DERAIL",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },

        {
          title: "COMMENTS",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },
        {
          title: "RESULT",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-rotate",
        },
      ],
    },

    data: [
      {
        heights: {
          header1: "50px",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "MILEPOST",
            colSpan: 1,
            rowSpan: 2,
            isValueOnly: true,
            centerAlign: true,
            className: "tbl-text-normal",
            accessor: "milepost",
          },
          {
            title: "TURNOUT NAME",
            colSpan: 2,
            rowSpan: 2,
            isValueOnly: true,
            centerAlign: true,
            className: "tbl-text-normal",
            accessor: "assetName",
          },
          {
            title: "A",
            colSpan: 1,
            rowSpan: 1,
            isTitleOnly: true,
            centerAlign: true,
            unBold: true,
            className: "tbl-text-normal",
          },
          {
            title: "SWITCH POINT OPENING",
            colSpan: 2,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: ["SPWNumStraight", "SPOFraction"],
            dontJoinValues: true,
            formatter: getFractionInches,
            className: "tbl-text-normal",
          },

          {
            title: "SWITCH POINT CONDITION",
            colSpan: 2,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            className: "tbl-text-normal",
            accessor: "SPointCStraight",
          },

          {
            title: "SW RODS",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "SRodsCStraight",
            className: "tbl-text-normal",
          },

          {
            title: "STOCK RAIL",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "SRailCStraight",
            className: "tbl-text-normal",
          },

          {
            title: "SW. LOCK",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "SLockCStraight",
            className: "tbl-text-normal",
          },

          {
            title: "SW LATCH",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "SLatchCStraight",
            className: "tbl-text-normal",
          },

          {
            title: "SW TARGET",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "STargetCStraight",
            className: "tbl-text-normal",
          },

          {
            title: "TURNOUT MAX GAGE",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "TMGageStaright",
            className: "tbl-text-normal",
          },

          {
            title: "FROG CONDITION",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "FrogConditionStraight",
            className: "tbl-text-normal",
          },

          {
            title: "FROG TRACK GAGE",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "FrogTrackGageStraight",
            className: "tbl-text-normal",
          },

          {
            title: "GUARD RAIL CONDITION",
            colSpan: 2,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "GuardRailConditionStraight",
            className: "tbl-text-normal",
          },

          {
            title: "GUARD FACE GAGE",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "GuardFaceGageStraight",
            className: "tbl-text-normal",
          },

          {
            title: "GUARD CHECK GAGE",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "GuardCheckGageStraight",
            className: "tbl-text-normal",
          },

          {
            title: "GAGE MEASUREMENTS OF THROW SWITCH",
            colSpan: 2,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "GMorTSStraight",
            className: "tbl-text-normal",
          },

          {
            title: "TIES",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "TiesStraight",
            className: "tbl-text-normal",
          },

          {
            title: "ANCHOR",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "AnchorStraight",
            className: "tbl-text-normal",
          },

          {
            title: "DERAIL",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "DerailStraight",
            className: "tbl-text-normal",
          },

          {
            title: "COMMENTS",
            colSpan: 2,
            rowSpan: 2,
            isValueOnly: true,
            centerAlign: true,
            accessor: "comments",
            className: "tbl-text-normal",
          },
          {
            title: "RESULT",
            colSpan: 2,
            rowSpan: 2,
            isValueOnly: true,
            centerAlign: true,
            accessor: "results",
            className: "tbl-text-normal",
          },
        ],
      },
      {
        heights: {
          header1: "50px",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "B",
            colSpan: 1,
            rowSpan: 1,
            isTitleOnly: true,
            centerAlign: true,
            unBold: true,

            className: "tbl-text-normal",
          },
          {
            title: "SW. POINT OPENING",
            colSpan: 2,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: ["SPWNumTurnout", "SPOFractionTurnout"],
            dontJoinValues: true,
            formatter: getFractionInches,
            className: "tbl-text-normal",
          },

          {
            title: "SW. POINT CONDITION",
            colSpan: 2,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "SPointCTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "SW. RODS",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "SRodsCTurnout",

            className: "tbl-text-normal",
          },

          {
            title: "STOCK RAIL",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "SRailCTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "SW. LOCK",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "SLockCTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "SW. LATCH",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "SLatchCTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "SW. TARGET",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "STargetCTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "TURNOUT MAX GAGE",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "TMGageTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "FROG CONDITION",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "FrogConditionTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "FROG TRACK GAGE",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "FrogTrackGageTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "GUARD RAIL CONDITION",
            colSpan: 2,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "GuardRailConditionTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "GUARD FACE GAGE",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "GuardFaceGageTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "GUARD CHECK GAGE",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "GuardCheckGageTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "GAGE MEASUREMENTS OF THROW SW.",
            colSpan: 2,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "GMorTSTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "TIES",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "TiesTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "ANCHOR",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "AnchorTurnout",
            className: "tbl-text-normal",
          },

          {
            title: "DERAIL",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            centerAlign: true,
            accessor: "DerailTurnout",
            className: "tbl-text-normal",
          },
        ],
      },
    ],
  },

  defectSection: {
    title: {
      heights: {
        header1: "auto",
      },
      headerOnly: true,
      classes: {
        header1: "grey-background",
      },
      columns: [
        {
          title: "DEFECT DETAILS",
          colSpan: 9,
          rowSpan: 1,
          className: "tbl-text-normal",
        },
      ],
    },

    header: {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      classes: { header1: "" },
      inlineBodyData: true,
      columns: [
        {
          title: "MILEPOST",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-normal",
        },
        {
          title: "TURNOUT NAME",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-normal",
        },

        {
          title: "DEFECT",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,

          className: "tbl-text-normal",
        },

        {
          title: "REMEDIAL ACTION",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-normal",
        },

        {
          title: "REPAIRED BY & DATE",
          colSpan: 1,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-normal",
        },
        {
          title: "SIGNATURE",
          colSpan: 2,
          rowSpan: 1,
          isTitleOnly: true,
          className: "tbl-text-normal",
        },
      ],
    },
    data: (assetRowSpan, index) => {
      const columns = [
        {
          title: "DEFECT",
          colSpan: 2,
          rowSpan: 1,
          isValueOnly: true,
          centerAlign: true,
          accessor: "description",
          className: "tbl-text-normal",
        },
        {
          title: "REMEDIAL ACTION",
          colSpan: 1,
          rowSpan: 1,
          isValueOnly: true,
          centerAlign: true,
          accessor: "remedialAction_slash_Comments",
          className: "tbl-text-normal",
        },

        {
          title: "REPAIRED BY & DATE",
          colSpan: 1,
          rowSpan: 1,
          isValueOnly: true,
          centerAlign: true,
          formatter: (val) => <div style={{ textAlign: "center" }}>{val}</div>,
          accessor: "repairedByAndDate",
          className: "tbl-text-normal",
        },

        {
          title: "SIGNATURE",
          colSpan: 2,
          rowSpan: 1,
          isValueOnly: true,
          centerAlign: true,
          accessor: "repairedBySignature",
          className: "tbl-text-normal",
        },
      ];

      if (index === 0) {
        columns.unshift(
          {
            title: "MILEPOST",
            colSpan: 1,
            rowSpan: assetRowSpan,
            isValueOnly: true,
            centerAlign: true,

            accessor: "milepost",
            className: "tbl-text-normal",
          },
          {
            title: "TURNOUT NAME",
            colSpan: 2,
            rowSpan: assetRowSpan,
            isValueOnly: true,
            centerAlign: true,

            accessor: "assetName",
            className: "tbl-text-normal",
          },
        );
      }

      return {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/SCFE/SwitchInspectionReport/SCFE_SwitchInspectionReportSchema.jsx